import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from '../styles/ModalSelect.module.css';

const Modal = ({ isOpen, onClose, children, pokemonName }) => {
    const [showModal, setShowModal] = useState(false);
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShowModal(true);
            setTimeout(() => {
                setAnimating(true);  // Lance l'animation d'entrée après affichage
            }, 10);  // Petit délai pour éviter que l'animation soit ignorée
        } else if (showModal) {
            setAnimating(false);  // Active l'animation de sortie
            setTimeout(() => {
                setShowModal(false);  // Retire la modal du DOM après fermeture
            }, 300);
        }
    }, [isOpen, showModal]);

    if (!showModal) return null;

    return ReactDOM.createPortal(
        <div className={`${styles.modal} ${animating ? styles.modalEnterActive : styles.modalHidden}`}>
            <div className={styles.modalContent}>
                {children}
            </div>
        </div>,
        document.body
    );
};

export default Modal;
